import { render, staticRenderFns } from "./DeleteReportModal.vue?vue&type=template&id=1605d445&scoped=true&"
import script from "./DeleteReportModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteReportModal.vue?vue&type=style&index=0&id=1605d445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605d445",
  null
  
)

export default component.exports